import { faker } from '@faker-js/faker';
import { ModalityLabel } from '@dynamika-shared/types/imagingLabels';
import { UploadFileTypeEnum } from '@dynamika-shared/types/inventory';

export function createRandomModalityLabel(): ModalityLabel {
  return {
    modalityName: faker.company.name(),
    labels: [
      {
        id: faker.string.uuid(),
        name: faker.company.name(),
        dataType: UploadFileTypeEnum.DICOM,
        inputDataType: UploadFileTypeEnum.DICOM,
      },
    ],
  };
}

export function createRandomModalityLabelList(count: number): ModalityLabel[] {
  return faker.helpers.multiple(createRandomModalityLabel, { count });
}

export function createPaginatedRandomClinicalTrialsList(count: number) {
  return createRandomModalityLabelList(count);
}
